(function () {
    'use strict';
    var m = angular.module('user-management');
    m.factory('userEdit', ["$q", "modals", "avananUserDao", "sideMenuManager", function ($q, modals, avananUserDao, sideMenuManager) {
        function showUserDialog(user, params, options, data) {
            var modalParams = angular.copy(params);
            if (data) {
                _(modalParams).each(function (param) {
                    param.data = data[param.id];
                });
            }
            return modals.params([{
                    lastPage: true,
                    params: modalParams,
                    okButton: options.okButton
                }], options.title).then(function (data) {
                return saveUser(user, params, options, data);
            });
        }
        function saveUser(user, params, options, data) {
            if (sideMenuManager.currentUser().admin) {
                var allow_only = _(userEdit.loginOptions).chain().map(function (option) {
                    if (data['allowLogin' + option.id]) {
                        return option.id;
                    }
                }).compact().value();
                // Commented out check. Current implementation always allows saml login, so it's possible to have empty array
                // Code below either should be removed completely or updated if saml logic is changed
                // if (allow_only.length === 0) {
                //     return modals.alert('Impossible to set no login options to user. Please select something.', {title: 'Error'})
                //         .then(function () {
                //             return showUserDialog(user, params, options, data);
                //         });
                // }
                user.allow_only = allow_only;
                user.admin = data.admin;
                user.view_private_data = data.view_private_data;
                user.send_alerts = data.send_alerts;
                user.receive_weekly_reports = data.receive_weekly_reports;
                user.role = data.role;
                if (options.userId && data.changePassword) {
                    user.password = data.password;
                }
            }
            $.extend(user, _(data).pick('first_name', 'last_name', 'email', 'description'));
            var promise;
            if (options.userId) {
                promise = avananUserDao.update(options.userId, user);
            } else {
                promise = avananUserDao.create(user);
            }
            return promise.then(_.noop, function (error) {
                modals.alert(error.data.message.split('\n'), { title: 'Error' }).then(function () {
                    return showUserDialog(user, params, options, data);
                });
            });
        }
        function userDialog(user) {
            var options = {};
            var isNew = true;
            if (user) {
                options.title = 'Update user';
                options.okButton = 'Update';
                options.userId = user.id;
                isNew = false;
            } else {
                options.title = 'Create new user';
                options.okButton = 'Create';
                user = {
                    first_name: '',
                    last_name: '',
                    email: '',
                    description: '',
                    role: 'user',
                    allow_only: []
                };
            }
            var params = [
                {
                    type: 'string',
                    id: 'first_name',
                    label: '* First name',
                    data: user.first_name,
                    validation: { required: { message: 'required' } }
                },
                {
                    type: 'string',
                    id: 'last_name',
                    label: '* Last name',
                    data: user.last_name,
                    validation: { required: { message: 'required' } }
                },
                {
                    type: 'string',
                    id: 'email',
                    label: '* Email',
                    data: user.email,
                    validation: {
                        required: { message: 'Email is required' },
                        'regexp': {
                            message: 'Please enter valid e-mail',
                            value: /.+@.+\..+/
                        }
                    }
                },
                {
                    type: 'string',
                    id: 'description',
                    label: 'Description',
                    data: user.description
                }
            ];
            if (sideMenuManager.currentUser().admin) {
                params.push({
                    type: 'radio-group',
                    id: 'role',
                    tooltip: true,
                    buttons: [
                        {
                            label: 'Admin',
                            value: 'admin',
                            tooltip: '\'Admin\' role has the highest privileges, can access any page and perform any operation'
                        },
                        {
                            label: 'User',
                            value: 'user',
                            tooltip: '\'User\' role has similar priveleges as the \'Admin\' role, except for accessing the user\'s management page and authorizing new Saas apps'
                        },
                        {
                            label: 'Operations',
                            value: 'operations',
                            tooltip: '\'Operations\' role is not allowed to stop, start or authorize saas apps, can not interact with policy rules and can not perform any actions on \'Custom Queries\''
                        },
                        {
                            label: 'Read Only',
                            value: 'read',
                            tooltip: '\'Read Only\' role can only read data and cannot perform any active actions within the platform.'
                        }
                    ],
                    validation: { required: { message: 'Please select user role' } },
                    emptyLabel: true,
                    label: '* Role',
                    data: user.role
                });
                params.push({
                    type: 'boolean',
                    id: 'view_private_data',
                    emptyLabel: true,
                    rightLabel: 'Allow drill-down into customer-data (detected email body, DLP found text etc)',
                    data: user.view_private_data
                });
                params.push({
                    type: 'boolean',
                    id: 'send_alerts',
                    emptyLabel: true,
                    rightLabel: 'Receive Alerts',
                    data: user.send_alerts
                });
                params.push({
                    type: 'boolean',
                    id: 'receive_weekly_reports',
                    emptyLabel: true,
                    rightLabel: 'Receive Reports',
                    data: isNew ? true : user.receive_weekly_reports
                });
                _(userEdit.loginOptions).each(function (option) {
                    var enabled = !user.allow_only || !_(user.allow_only).isArray() || _(user.allow_only).contains(option.id);
                    params.push({
                        type: 'boolean',
                        id: 'allowLogin' + option.id,
                        emptyLabel: true,
                        rightLabel: option.label,
                        data: enabled
                    });
                });
                if (options.userId) {
                    params.push({
                        type: 'boolean',
                        id: 'changePassword',
                        emptyLabel: true,
                        rightLabel: 'Change User Password',
                        data: false,
                        enabled: [{
                                param: 'allowLoginpassword',
                                equal: true
                            }]
                    });
                    params.push({
                        type: 'password',
                        id: 'password',
                        label: 'New User Password',
                        enabled: [
                            {
                                param: 'allowLoginpassword',
                                equal: true
                            },
                            {
                                param: 'changePassword',
                                equal: true
                            }
                        ],
                        validation: { required: { message: 'Password can not be empty' } }
                    });
                    params.push({
                        type: 'password',
                        id: 'password',
                        label: 'Re-type New Password',
                        enabled: [
                            {
                                param: 'allowLoginpassword',
                                equal: true
                            },
                            {
                                param: 'changePassword',
                                equal: true
                            }
                        ],
                        validation: {
                            equalTo: {
                                message: 'Re-typed password doesn\'t match',
                                value: 'password'
                            }
                        }
                    });
                }
            }
            return showUserDialog(user, params, options);
        }
        var userEdit = {
            loginOptions: [
                {
                    id: 'google',
                    label: 'Allow Google oauth login'
                },
                {
                    id: 'password',
                    label: 'Allow password login'
                }
            ],
            createUser: function () {
                return userDialog();
            },
            editUser: function (userId) {
                return avananUserDao.retrieve(userId).then(function (user) {
                    return userDialog(user.data);
                });
            }
        };
        return userEdit;
    }]);
}());